import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import * as moment from 'moment';
import { DatePickerFormat } from 'src/app/core/interfaces/date-picker-format';

@Component({
  selector: 'app-custom-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomDatePickerComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CustomDatePickerComponent,
    },
  ],
})
export class CustomDatePickerComponent {
  @Input()
  title = "Select date...";

  @Input()
  isDisabled = false;

  @Input()
  public minDate: DatePickerFormat = { year: 1900, month: 1, day: 1 };
  public maxDate: DatePickerFormat = { year: 2500, month: 1, day: 1 };

  public value?: string;
  public localValue?: any;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;

  disabled = false;

  writeValue(val: string) {
    this.value = val;
    if (this.value) {
      this.localValue = this.getFormattedObject(this.value);
    }
  }

  valueChanged(value: any) {
    this.onChange(this.getFormattedString(value)!);
  }

  getFormattedString(val: any) {
    if (val) {
      return `${val?.year.toString().padStart(4, '0')}-${val?.month.toString().padStart(2, '0')}-${val?.day.toString().padStart(2, '0')}`;
    }
    return null;
  }

  getFormattedObject(val: string) {
    const splitted = val.split('-');

    return {
      year: splitted[0],
      month: splitted[1],
      day: splitted[2],
    };
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
